import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from "@angular/http";
import { ErrorHandler, NgModule } from "@angular/core";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { Clipboard } from "@ionic-native/clipboard";

import { MyApp } from "./app.component";
import { LoginPage } from "../pages/user/login";

//FODEL DRIVER MANAGER
import { HomePage } from "../pages/dvm/home/home";
import { DriverListPage } from "../pages/dvm/driver/list/index";
import { ClientListPage } from "../pages/dvm/clients/list/index";

/*WAREHOUSE APP PAGES*/
import { WhIndexPage } from "../pages/wh/index/index";
import { ParcelListPage } from "../pages/wh/parcels_list/index";
import { ParcelDetailPage } from "../pages/wh/parcel_detail/index";

/*BACKOFFICE APP PAGES*/
import { DvSummaryPage } from "../pages/backoffice/driver/summary/index";
import { WhSummaryPage } from "../pages/backoffice/overall/summary/index";
import { AreaSummaryPage } from "../pages/backoffice/area/summary/index";
import { DriverMapPage } from "../pages/dvm/driver/map/index";

import { ShipmentsPage } from "../pages/backoffice/shipments/shipments";
import { WhActionHistoryPage } from "../pages/backoffice/overall/history/index";
import { WhActiveParcelsSummaryPage } from "../pages/backoffice/overall/active_parcels/index";

import { ShipmentsDetailPage } from "../pages/backoffice/shipments/shipments.modal";
import { EcommercePage } from "../pages/backoffice/ecomerce/ecomerce";
import { EcommerceDashboard } from "../pages/backoffice/ecomerce/dashboard/dashboard";
import { ChangeDriverPage } from "../pages/backoffice/ecomerce/ecomerce.modal";

/*CUSTOM COMPONENTS*/
import { CustomHeaderComponent } from "../pages/common/header/custom-header-component";
import { CustomSidebarComponent } from "../pages/common/sidebar/custom-sidebar";

//Modals
import { ChangeTimingCpModalComponent } from "../pages/backoffice/collecion-points/change-timing-cp-modal/change-timing-cp-modal";
import { ChangeBasicInfoCpModalComponent } from "../pages/backoffice/collecion-points/edit-cp-basic-info/edit-cp-basic-info-modal";
import { ChangeUserInfoCpModalComponent } from "../pages/backoffice/collecion-points/edit-cp-user-info/edit-cp-user-info-modal";
import { TransferSiteModalComponent } from "../pages/backoffice/shipments/transfer-site-modal/transfer-site-modal";

/*PROVIDERS*/
import { AuthService } from "../providers/auth-service";
import { IonicStorageModule } from "@ionic/storage";
import { SummaryServiceProvider } from "../providers/wh/summary-service";

import { APP_INITIALIZER } from "@angular/core";

//FODEL QUICK DASHBOARD APP PAGES

import { SearchParcel } from "../pages/qdb/search-parcel/index";
import { ParcelDashboard } from "../pages/qdb/parcel-dashboard/index";
import { DriverDashboard } from "../pages/qdb/driver-dashboard/index";
import { WaybillOrderServiceProvider } from "../providers/qdb/qdb-service";
import { DatePipe } from "@angular/common";

import { ConfigurationService } from "ionic-configuration-service";

import { TicketsPage } from "../pages/backoffice/tickets";
import { TicketAddPage } from "../pages/backoffice/tickets/add/add";
import { TicketDetailPage } from "../pages/backoffice/tickets/details/details";

import { CollectionPointPage } from "../pages/backoffice/collecion-points";
import { ProfileInformationPage } from "../pages/backoffice/profile-information";
import { RTOHoldList } from "../pages/backoffice/rto-hold-list";

import { AddSitesPage } from "../pages/backoffice/add-sites";
import { AddSitesModalComponent } from "../pages/backoffice/add-sites/add-sites-modal/add-sites-modal";
import { DownloadPDFModalComponent } from "../pages/backoffice/add-sites/dowload-pdf-modal/dowload-pdf-modal";
import { ChangePasswordModalComponent } from "../pages/backoffice/add-sites/change-pass-modal/change-pass-modal";

import { Camera } from "@ionic-native/camera";
import { FileTransfer, FileTransferObject } from "@ionic-native/file-transfer";
import { File } from "@ionic-native/file";
import { FileOpener } from "@ionic-native/file-opener";
import { HoldRtoModalComponent } from "../pages/qdb/search-parcel/hold-rto-modal/hold-rto-modal";
import { ConfirmCancellationModalComponent } from "../pages/qdb/search-parcel/confirm-cancellation-modal/confirm-cancellation-modal";
import { SelectAreaModalComponent } from "../pages/backoffice/collecion-points/select-area-modal/select-area-modal";
import { ListCPUsersModalComponent } from "../pages/backoffice/collecion-points/list-cp-users-modal/list-cp-users-modal";
import { AddUserCpModalComponent } from "../pages/backoffice/collecion-points/add-cp-user-info/add-cp-user-info-modal";
import { ListRTODaysModalComponent } from "../pages/backoffice/collecion-points/list-rto-days-modal/list-rto-days-modal";
import { ChangeNationalAddressInfoCpModalComponent } from "../pages/backoffice/collecion-points/edit-cp-national-address-info/edit-cp-national-address-info-modal";
import { CreateDHLShipment } from "../pages/backoffice/create-dhl-shipment";

export function loadConfiguration(
  configurationService: ConfigurationService
): () => Promise<void> {
  return () => configurationService.load("assets/settings.json");
}

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    CustomHeaderComponent,
    CustomSidebarComponent,
    DriverListPage,
    ClientListPage,
    WhIndexPage,
    ParcelListPage,
    ParcelDetailPage,
    SearchParcel,
    ParcelDashboard,
    DriverDashboard,
    WhSummaryPage,
    WhActionHistoryPage,
    WhActiveParcelsSummaryPage,
    DvSummaryPage,
    AreaSummaryPage,
    DriverMapPage,
    ShipmentsPage,
    ShipmentsDetailPage,
    EcommercePage,
    ChangeDriverPage,
    EcommerceDashboard,
    TicketsPage,
    CollectionPointPage,
    TicketAddPage,
    TicketDetailPage,
    ChangeTimingCpModalComponent,
    ChangeBasicInfoCpModalComponent,
    ChangeUserInfoCpModalComponent,
    TransferSiteModalComponent,
    ProfileInformationPage,
    AddSitesPage,
    AddSitesModalComponent,
    DownloadPDFModalComponent,
    SelectAreaModalComponent,
    ChangePasswordModalComponent,
    HoldRtoModalComponent,
    ConfirmCancellationModalComponent,
    RTOHoldList,
    CreateDHLShipment,
    ListCPUsersModalComponent,
    ChangeNationalAddressInfoCpModalComponent,
    AddUserCpModalComponent,
    ListRTODaysModalComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../pages/dvm/area/list/index.module#DriverDetailPageModule', name: 'AreaListPage', segment: 'index', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/dvm/clients/driver_model/modal.module#DriverPageModule', name: 'DriverPageModel', segment: 'modal', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/dvm/driver-detail/driver-detail.module#DriverDetailPageModule', name: 'DriverDetailPage', segment: 'driver-detail', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/dvm/modal/modal.module#ModalPageModule', name: 'ModalPage', segment: 'modal', priority: 'low', defaultHistory: [] }
  ]
}),
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    DriverListPage,
    ClientListPage,
    WhIndexPage,
    ParcelListPage,
    ParcelDetailPage,
    SearchParcel,
    ShipmentsPage,
    ShipmentsDetailPage,
    EcommercePage,
    EcommerceDashboard,
    ChangeDriverPage,
    ParcelDashboard,
    DriverDashboard,
    WhSummaryPage,
    WhActionHistoryPage,
    WhActiveParcelsSummaryPage,
    DvSummaryPage,
    AreaSummaryPage,
    DriverMapPage,
    TicketsPage,
    TicketAddPage,
    TicketDetailPage,
    CollectionPointPage,
    ChangeTimingCpModalComponent,
    ChangeBasicInfoCpModalComponent,
    ChangeUserInfoCpModalComponent,
    TransferSiteModalComponent,
    ProfileInformationPage,
    AddSitesPage,
    AddSitesModalComponent,
    DownloadPDFModalComponent,
    ChangePasswordModalComponent,
    SelectAreaModalComponent,
    ConfirmCancellationModalComponent,
    HoldRtoModalComponent,
    RTOHoldList,
    CreateDHLShipment,
    ListCPUsersModalComponent,
    AddUserCpModalComponent,
    ListRTODaysModalComponent,
    ChangeNationalAddressInfoCpModalComponent
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AuthService,
    DatePipe,
    IonicStorageModule,
    WaybillOrderServiceProvider,
    SummaryServiceProvider,
    Camera,
    File,
    FileOpener,
    Clipboard,
    FileTransfer,
    FileTransferObject,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    ConfigurationService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfiguration,
      deps: [ConfigurationService],
      multi: true,
    },
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts